import { request } from '@umijs/max';
import { getNebulithInferenceProApiUrl } from '@/services/util';

export interface InferenceModelListItem {
  inferenceModelId: string;
  modelName: string;
  modelTypeCode?: string;
  modelTypeId?: string;
  modelTypeName?: string;
  status?: string;
}

export interface InferenceModelListResult {
  list: InferenceModelListItem[];
}

export interface InferenceModelListParams {
  modelName?: string;
  modelTypeId?: string;
  status?: string;
}

/** 推理模型列表（筛选用） */
export async function getInferenceModelList(
  params?: InferenceModelListParams,
  options?: { skipErrorHandler?: boolean },
) {
  const res = await request<InferenceModelListResult | InferenceModelListItem[]>(
    getNebulithInferenceProApiUrl('inference-model/list'),
    {
      method: 'POST',
      data: params ?? {},
      ...(options || {}),
    },
  );
  if (Array.isArray(res)) {
    return res;
  }
  return res?.list ?? [];
}

let inferenceModelListPromise: Promise<InferenceModelListItem[]> | null = null;

export function getInferenceModelListCached() {
  if (!inferenceModelListPromise) {
    inferenceModelListPromise = getInferenceModelList().catch((error) => {
      inferenceModelListPromise = null;
      throw error;
    });
  }
  return inferenceModelListPromise;
}

export const toInferenceModelOptions = (list?: InferenceModelListItem[]) =>
  [...(list ?? [])].map((item) => ({
    label: item.modelName,
    value: item.inferenceModelId,
  }));
